import React, { useState, useEffect } from "react";
import * as moment from "moment";

import { INVEST_OPTIONS } from "../../../../../../../../constants";
import { Util } from "../../../../../../../../helpers/util";
import { $api } from "../../../../../../../../helpers/$api";
import successicon from "../../../../../assets/success-icon.svg";
import "./SilverInvestmentDetails.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
// import backtick from "../../../../../assets/backtick.svg";

const InvestNow = ({ setPage }) => {
  const [balance, setBalance] = useState(0);
  const options = Util.get(INVEST_OPTIONS);
  const [showRoiInfo, setShowRoiInfo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { packageId, amount, returnType, package_name } = options;
  const { currency} = Util.getCurrency();


  useEffect(() => {
    (async () => {
      try {
        const { wallet_balance } = await $api.user.getBalances();

        setBalance(wallet_balance);
      } catch (error) {
        // ...
      }
    })();
  }, [setBalance]);

  return (
    <div className="startinvestment-body">
      <div className="startinvestment-main">
        <div className="confirminvestment-main">
          <h5 className="confirminvestment-h5"> Invest Now</h5>
          <p className="confirminvestment-textbody mt-2">
            Choose Payment Method
          </p>
        </div>
        <div className="silverplan">
          <p className="fundwith-header">Fund With</p>
          <hr className="hr" />
          <div className="silverplan-flex">
            <div className="ovest-wallet">
              <p className="ovestwallet-main">Ovest Wallet</p>
              <div className="investamount">
                <p className="investamount-balance mt-4">
                  Balance: {currency}{(+balance.toFixed(2)).toLocaleString()}
                </p>
                {/* <p
                  className="investamount-mini mb-2"
                  onClick={() => setPage(4)}
                >
                  Change this{" "}
                  <span>
                    <img src={backtick} alt="" className="ml-2" />
                  </span>{" "}
                </p> */}
              </div>
              {balance < amount && (
                <p className="funds-p mt-5">
                  Insufficient funds. <span>Fund wallet</span>
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="note-main p-4 mb-4">
          <p className="funds-deduction">
            Funds will be deducted automatically from your available payment
            method(s) on OVest.
          </p>
        </div>
        {/* <div className="checkbox-main">
          <input type="checkbox" name="" id="" className="checkbox-input" />
          <label htmlFor="" className="termsandcondition">
            By clicking this, you’ve agreed to
            <span> OVest terms and conditions</span>
          </label>
        </div> */}
        <button
          className={
            amount > balance || isSubmitting ? "claim-property" : "invest"
          }
          disabled={amount > balance || isSubmitting}
          onClick={async () => {
            try {
              if (!isSubmitting) {
                setIsSubmitting(true);
                await $api.user.invest({
                  amount_to_invest: amount,
                  start_date: moment().format("YYYY-mm-DD"),
                  payment_method: "ovest_wallet",
                  package_id: packageId,
                  return_type: returnType,
                });

                setShowRoiInfo(true);
              }
            } catch (error) {
              toast.error(`error investing: ${error.message}`);
            } finally {
              setIsSubmitting(false);
            }
          }}
        >
          Securely Invest {currency}{(+amount.toFixed(2)).toLocaleString()}
        </button>
      </div>
      <div
        className={`silverinvestment__roi-info-bg ${
          showRoiInfo ? "show-roi-info" : ""
        }`}
      >
        <div className="silverinvestment__roi-info-content">
          <div className="profit-roi-modal">
            <div className="p">
              <div className="success-img-icon">
                <img
                  src={successicon}
                  alt="close-modal"
                  className="close-icon-btn"
                  onClick={() => setShowRoiInfo(false)}
                />
              </div>
              <p className="profit-roi-textbody pl-5 pr-5">
                You have successfully subscribed to {package_name} with
                <span> {currency}{(+amount.toFixed(2)).toLocaleString()} </span> debited
                from your OVest wallet
              </p>
              <div className="go-to-dashboard">
                <Link to="/dashboard">
                  <button className="go-to-dashboard-btn">
                    Go to Dashboard
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestNow;
